import React, { useState } from 'react'
import { Panel, PanelHeaderTemplateOptions, PanelProps } from 'primereact/panel'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'

export interface SeparablePanelProps extends PanelProps {
  modalHeader?: React.ReactNode
  modalWidth?: number
}

const SeparablePanel: React.FC<SeparablePanelProps> = props => {
  const { modalHeader, modalWidth, header, children, ...rest } = props
  const [modalVisible, setModalVisible] = useState<boolean>(false)

  const openModal = () => {
    setModalVisible(true)
  }

  const closeModal = () => {
    setModalVisible(false)
  }

  // 独自のheaderTemplateを定義
  const customHeaderTemplate = (options: PanelHeaderTemplateOptions) => {
    return (
      <div className={options.className}>
        <span className="p-panel-title">{header}</span>
        <div className="p-panel-icons">
          <Button
            type="button"
            icon="pi pi-external-link"
            className="p-panel-modal-toggler p-button-link"
            onClick={openModal}
          />
          {options.togglerElement}
        </div>
      </div>
    )
  }

  return (
    <>
      {!modalVisible && (
        <Panel header={header} headerTemplate={customHeaderTemplate} {...rest}>
          {children}
        </Panel>
      )}
      <Dialog
        visible={modalVisible}
        header={modalHeader ? modalHeader : header}
        onHide={closeModal}
        style={{
          maxWidth: 'calc(100% - 20px)',
          width: modalWidth ? modalWidth : '100vw',
        }}
        modal={false}
        resizable
      >
        {children}
      </Dialog>
    </>
  )
}

export default SeparablePanel
